<!--
 * @Author: wzh
 * @LastEditTime: 2025-05-26 12:00:32
 * @Description: 在线应用（按应用分类展示）
-->
<template>
  <div class="home">
    <header class="head">{{ $t("home.my_app.title") }}</header>
    <a-spin :spinning="loading">
      <a-input-search
        v-model="value"
        class="app-search"
        placeholder="请输入应用名称搜索"
        :loading="btnLoadding"
        @change="onSearch"
        @search="onSearch"
        enter-button
      />
      <template v-if="groupedApps.length">
        <section
          v-for="group in groupedApps"
          :key="group.categoryId"
          class="category-block"
        >
          <div class="category-title">
            <span class="category-name">{{ group.categoryName }}</span>
            <span class="category-count">{{ group.apps.length }}</span>
          </div>
          <div class="my-app">
            <div
              v-for="(item, index) in group.apps"
              :key="item.id || index"
              class="box"
              @click="jumpUrl(item)"
            >
              <div class="box-flex">
                <div class="app-icon-wrap">
                  <img
                    class="app-icon"
                    :src="
                      item.iconBase64 ||
                      require(
                        '@/assets/images/myapp/app_icon' + (index % 5) + '.png'
                      )
                    "
                    alt=""
                  />
                </div>
                <span class="app-name" :style="{ fontSize: appNameFontSize }">{{
                  item.appName
                }}</span>
              </div>
            </div>
          </div>
        </section>
      </template>
      <a-empty
        v-else
        :image="simpleImage"
        :description="$t('home.my_app.not_app')"
      />
    </a-spin>
  </div>
</template>

<script>
import { commonAPI } from "@/apis";
import { Empty } from "ant-design-vue";

export default {
  name: "Home",
  data() {
    return {
      allApps: [],
      loading: false,
      btnLoadding: false,
      value: "",
    };
  },
  computed: {
    appNameFontSize() {
      const size =
        (window.ipConfigUrl && window.ipConfigUrl.appNameFontSize) || 15;
      return typeof size === "number" ? `${size}px` : String(size);
    },
    filteredApps() {
      const keyword = (this.value || "").trim();
      if (!keyword) {
        return this.allApps;
      }
      return this.allApps.filter(
        (item) => item.appName && item.appName.includes(keyword)
      );
    },
    groupedApps() {
      const map = new Map();
      this.filteredApps.forEach((app) => {
        const categoryId = app.category || "uncategorized";
        const categoryName = app.categoryName || "未分类";
        const categorySort = app.categorySort || "9999";
        if (!map.has(categoryId)) {
          map.set(categoryId, {
            categoryId,
            categoryName,
            categorySort,
            apps: [],
          });
        }
        map.get(categoryId).apps.push(app);
      });
      return Array.from(map.values()).sort((a, b) => {
        const sa = Number(a.categorySort);
        const sb = Number(b.categorySort);
        const na = Number.isNaN(sa) ? Number.MAX_SAFE_INTEGER : sa;
        const nb = Number.isNaN(sb) ? Number.MAX_SAFE_INTEGER : sb;
        if (na !== nb) {
          return na - nb;
        }
        return String(a.categoryName).localeCompare(String(b.categoryName), "zh");
      });
    },
  },
  beforeCreate() {
    this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;
      const { code, data } = await commonAPI.getAction("/appList");
      if (code == 0) {
        this.allApps = data || [];
      } else {
        this.allApps = [];
      }
      this.loading = false;
    },
    onSearch() {
      this.btnLoadding = true;
      this.$nextTick(() => {
        this.btnLoadding = false;
      });
    },
    jumpUrl(item) {
      if (item.status == 2) {
        this.$message.warning(this.$t("home.my_app.tip"));
        return;
      }
      if (item.loginUrl) {
        window.open(item.loginUrl);
      } else {
        this.$message.warning(this.$t("home.my_app.not_app"));
      }
    },
  },
};
</script>

<style lang="scss">
.home {
  .head {
    font-size: 18px;
    font-weight: 600;
    color: #1a2340;
    margin-bottom: 16px;
    letter-spacing: 0.2px;
  }
  .app-search {
    width: 320px;
    margin-bottom: 20px;
    .ant-input {
      border-radius: 8px 0 0 8px;
      border-color: #e6e9f0;
      &:hover,
      &:focus {
        border-color: #f08a24;
      }
    }
    .ant-input-search-button {
      border-radius: 0 8px 8px 0;
    }
  }
  .category-block {
    margin-bottom: 18px;
    padding: 14px 16px 16px;
    background: #fff;
    border: 1px solid #eef0f5;
    border-radius: 12px;
    box-shadow: 0 1px 2px rgba(26, 35, 64, 0.03);
  }
  .category-title {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
    padding-left: 10px;
    border-left: 3px solid #f08a24;
    line-height: 1.2;
    .category-name {
      font-size: 15px;
      font-weight: 600;
      color: #1f2a5a;
    }
    .category-count {
      min-width: 22px;
      height: 20px;
      padding: 0 7px;
      border-radius: 999px;
      background: rgba(240, 138, 36, 0.12);
      color: #d97706;
      font-size: 12px;
      font-weight: 600;
      line-height: 20px;
      text-align: center;
    }
  }
  .my-app {
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    gap: 12px;
    .box {
      width: 100%;
      height: 100%;
      background: #f8f9fc;
      border-radius: 10px;
      border: 1px solid transparent;
      cursor: pointer;
      transition: background 0.18s ease, border-color 0.18s ease,
        box-shadow 0.18s ease, transform 0.18s ease;
      .box-flex {
        display: flex;
        align-items: center;
        padding: 10px 12px;
        min-height: 56px;
      }
      .app-icon-wrap {
        width: 40px;
        height: 40px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        background: #fff;
        box-shadow: 0 1px 3px rgba(26, 35, 64, 0.06);
      }
      .app-icon {
        width: 28px;
        height: 28px;
        object-fit: contain;
        border-radius: 6px;
      }
      .app-name {
        font-size: 15px;
        color: #1a2340;
        margin-left: 10px;
        line-height: 1.4;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      &:hover {
        background: #fff !important;
        border-color: rgba(240, 138, 36, 0.35);
        box-shadow: 0 6px 16px rgba(26, 35, 64, 0.08);
        transform: translateY(-1px);
        .app-name {
          color: #c56a12;
        }
      }
      &:active {
        transform: translateY(0);
        box-shadow: 0 2px 8px rgba(26, 35, 64, 0.06);
      }
    }
  }
  @media (max-width: 1400px) {
    .my-app {
      grid-template-columns: repeat(5, minmax(0, 1fr));
    }
  }
  @media (max-width: 1100px) {
    .my-app {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
  }
}
</style>
